/*
 * @@Description: 加强版emit  => element源码
 * @@Author: MuYang
 * @Date: 2021-09-01 17:09:45
 * @LastEditTime: 2021-10-14 11:00:39
 */

function broadcast (componentName, eventName, params) {
  const { $children } = this
  let child, name
  for (let i = 0; i < $children.length; i++) {
    child = $children[i]
    name = child.$options.componentName || child.$options.name
    if (name === componentName) {
      child[eventName] && child[eventName](params)
      break
    }
    broadcast.apply(child, [componentName, eventName].concat([params]))
  }
}

export default {
  methods: {
    dispatch (componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName || parent.$options.name

      // 不是数组
      if (!Array.isArray(componentName)) {
        componentName = [componentName]
      }

      while (parent && (!name || !componentName.includes(name))) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.componentName || parent.$options.name
        }
      }

      if (parent) {
        const payload = Array.isArray(params) ? [params] : params
        parent.$emit.apply(parent, [eventName].concat(payload))
      }
    },
    broadcast (componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params)
    }
  }
}
